import Vue from 'vue/dist/vue';

export class Manufacturer {
    constructor(initialize = null) {
        if (initialize) this.Convert(initialize);
        else {
            this.ManufacturerCode = 'Not Set';
            this.Description = 'Not Set';
        }
        this.All = [
            {
                ManufacturerCode: 'AL',
                Description: 'Autolite Spark Plugs',
            },
            {
                ManufacturerCode: 'B3C',
                Description: 'B3C Fuel Solutions',
            },
            {
                ManufacturerCode: 'BS',
                Description: 'Briggs and Stratton',
            },
            {
                ManufacturerCode: 'CAR',
                Description: 'Carlton Forestry Products',
            },
            {
                ManufacturerCode: 'CO',
                Description: 'Core Outdoor Power',
            },
            {
                ManufacturerCode: 'CP',
                Description: 'Champion Spark Plugs',
            },
            {
                ManufacturerCode: 'CSD',
                Description: 'Consignment Snowdog',
            },
            {
                ManufacturerCode: 'DAY',
                Description: 'Daye',
            },
            {
                ManufacturerCode: 'DC',
                Description: "Dealer's Choice",
            },
            {
                ManufacturerCode: 'DEN',
                Description: 'Denso Spark Plug',
            },
            {
                ManufacturerCode: 'DOL',
                Description: 'Dolmar Power Products',
            },
            {
                ManufacturerCode: 'EG',
                Description: 'Eagle Safety Cans',
            },
            {
                ManufacturerCode: 'EHP',
                Description: 'Electrolux Home Products',
            },
            {
                ManufacturerCode: 'FNA',
                Description: 'FNA Pressure Washer',
            },
            {
                ManufacturerCode: 'GAT',
                Description: 'Gates Belts',
            },
            {
                ManufacturerCode: 'GE',
                Description: 'Gold Eagle',
            },
            {
                ManufacturerCode: 'GEN',
                Description: 'Generac (Gardner)',
            },
            {
                ManufacturerCode: 'GT',
                Description: 'General Transmissions',
            },
            {
                ManufacturerCode: 'HG',
                Description: 'Hydro Gear (Gardner)',
            },
            {
                ManufacturerCode: 'HOP',
                Description: 'Hop Parts Test',
            },
            {
                ManufacturerCode: 'KIN',
                Description: 'Kinetix Oil',
            },
            {
                ManufacturerCode: 'KH',
                Description: 'Kohler (Gardner)',
            },
            {
                ManufacturerCode: 'MER',
                Description: 'Yard Force',
            },
            {
                ManufacturerCode: 'MP',
                Description: 'Masport Power Equipment',
            },
            {
                ManufacturerCode: 'MTD',
                Description: 'MTD (Gardner)',
            },
            {
                ManufacturerCode: 'NGK',
                Description: 'NGK Spark Plugs',
            },
            {
                ManufacturerCode: 'NSC',
                Description: 'No-Spill Fuel Cans',
            },
            {
                ManufacturerCode: 'OCS',
                Description: 'Oregon Cutting Systems',
            },
            {
                ManufacturerCode: 'OEP',
                Description: 'Oregon Equipment Parts',
            },
            {
                ManufacturerCode: 'OP',
                Description: 'Interlube Intl. (Opti)',
            },
            {
                ManufacturerCode: 'OPE',
                Description: 'Oregon Power Equipment',
            },
            {
                ManufacturerCode: 'RAP',
                Description: 'Rapco Industries (Chain)',
            },
            {
                ManufacturerCode: 'ROT',
                Description: 'Rotary XRef',
            },
            {
                ManufacturerCode: 'SB',
                Description: 'Star Brite Products',
            },
            {
                ManufacturerCode: 'SCH',
                Description: 'SPEED CINCH',
            },
            {
                ManufacturerCode: 'SD',
                Description: 'Snow Dog Wholegoods',
            },
            {
                ManufacturerCode: 'SEF',
                Description: 'VP Small Engine Fuels',
            },
            {
                ManufacturerCode: 'SF',
                Description: 'Sea Foam',
            },
            {
                ManufacturerCode: 'SPC',
                Description: 'Spectrum Corp. (Oil)',
            },
            {
                ManufacturerCode: 'SM',
                Description: 'Catalytic Combustion Corp',
            },
            {
                ManufacturerCode: 'SUM',
                Description: 'Sumec',
            },
            {
                ManufacturerCode: 'TM',
                Description: 'TrailerMate Trailers',
            },
            {
                ManufacturerCode: 'WAL',
                Description: 'Walbro Carburetors and Parts',
            },
            {
                ManufacturerCode: 'WX',
                Description: 'Worx Outdoor',
            },
            {
                ManufacturerCode: 'ZAM',
                Description: 'Zama Carburetors and Parts',
            },
            {
                ManufacturerCode: 'ZZZZ',
                Description: 'Discontinued Products',
            },
            {
                ManufacturerCode: 'JDNA',
                Description: 'JDNA',
            },
            {
                ManufacturerCode: 'PION',
                Description: 'Pioneer Power Equipment',
            },
            {
                ManufacturerCode: 'GM',
                Description: 'Hyper Hough',
            },
            {
                ManufacturerCode: 'HYP',
                Description: 'Green Machine',
            },
        ];
    }
    SetManufacturerCode(manCode) {
        this.Convert(manCode);
    }
    SetDescription(description) {
        this.Convert(description);
    }
    Convert(input) {
        // eslint-disable-next-line array-callback-return
        const match = this.All.filter((brand) => {
            if (input === brand.ManufacturerCode || brand.Description.includes(input)) return true;
        });
        if (match.length) {
            this.ManufacturerCode = match[0].ManufacturerCode;
            this.Description = match[0].Description;
        } else {
            console.warn('No match found');
        }
    }
}

export const searchParentElements = (element, { type, value = null }, max = 'body') => {
    let res = null;
    if (!(element instanceof HTMLElement)) {
        console.error(`Element is not an HTMLElement and is instead: ${element}`);
        return res;
    }
    if (!type) {
        console.error(`Attribute type is not specified and is instead: ${type}`);
        return res;
    }
    if (value) {
        res = false;
        if (element.hasAttribute(type)) {
            res = element.getAttribute(type) === value;
        } else {
            if (element.tagName.toLowerCase() === max) {
                console.warn(`${type} = ${value} was not found on the page`);
                return res;
            }
            res = searchParentElements(element.parentElement, {
                type,
                value,
            });
        }
    } else {
        res = ``;
        if (element.hasAttribute(type)) {
            res = element.getAttribute(type);
        } else {
            if (element.tagName.toLowerCase() === max) {
                console.warn(`${type} was not found within the specified range`);
                return res;
            }
            res = searchParentElements(element.parentElement, {
                type,
            });
        }
    }
    return res;
};

export function formatMoney(x) {
    if (typeof x !== 'number') {
        return x;
    }
    return `$${x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function isDaylightSavingTime(currentDate) {
    currentDate = new Date(currentDate);
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    let DSD = null;
    const scanDate = currentDate;
    switch (month) {
        case 1:
        case 2:
        case 12:
            return false;
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
            return true;
        case 3:
            if (day < 8) return false;
            else if (day > 14) return true;
            for (let i = 8; i < 15; i++) {
                scanDate.setDate(i);
                if (scanDate.getDay() === 0) {
                    DSD = scanDate.getDate();
                }
            }
            if (day >= DSD && currentDate.getHours() >= 2) return true;
            return false;
        case 11:
            if (day > 7) return false;
            for (let i = 1; i < 8; i++) {
                scanDate.setDate(i);
                if (scanDate.getDay() === 0) {
                    DSD = scanDate.getDate();
                }
            }
            if (day >= DSD && currentDate.getHours() >= 2) return false;
            return true;
        default:
            return true;
    }
}

export function getUTCOffSet(time, zone) {
    const DST = {
        ET: -4,
        CT: -5,
        MT: -6,
        PT: -7,
        ALASKA: -8,
    };
    const ST = {
        ET: -5,
        CT: -6,
        MT: -7,
        PT: -8,
        ARIZONA: -7,
        ALASKA: -9,
        HAWAII: -10,
    };
    if (isDaylightSavingTime(time)) return DST[zone] || ST[zone];
    return ST[zone];
}

export function getWarehouseTimezoneOffSet(code) {
    const warehouseTZ = {
        '06': 'ET',
        26: 'ET',
        36: 'ET',
        46: 'ET',
        57: 'PT',
        58: 'CT',
        66: 'PT',
        77: 'CT',
        78: 'PT',
    };
    return Math.abs(getUTCOffSet(Date.now(), warehouseTZ[code]));
}

export function getWarehouseLocation(code) {
    switch (code) {
        case '06':
            return 'Columbus, OH';
        case '26':
            return 'Castleton, NY';
        case '36':
            return 'Charlotte, NC';
        case '46':
            return 'Pendergrass, GA';
        case '57':
            return 'Tigard, OR';
        case '58':
            return 'Dallas, TX';
        case '66':
            return 'Visalia, CA';
        case '77':
            return 'Ankeny, IA';
        case '78':
            return 'Salt Lake City, UT';
    }
}

const _isDate = (input) => {
    let result = false;

    if (input) {
        const parts = {
            slash: input.split('/'),
            dash: input.split('-'),
        };
        if (parts.slash.length === 3) {
            const month = parseInt(parts.slash[0], 10);
            const day = parseInt(parts.slash[1], 10);
            const year = parseInt(parts.slash[2], 10);

            const isDateFormat = VALIDATE.isDateFormat(input);
            const isMonth = VALIDATE.isMonth(month);
            const isDay = VALIDATE.isDay(day, month, year);
            const isYear = VALIDATE.isYear(year);
            if (isDateFormat && isMonth && isDay && isYear) result = true;
        }
        if (parts.dash.length === 3) {
            const month = parseInt(parts.dash[0], 10);
            const day = parseInt(parts.dash[1], 10);
            const year = parseInt(parts.dash[2], 10);

            const isDateFormat = VALIDATE.isDateFormat(input);
            const isMonth = VALIDATE.isMonth(month);
            const isDay = VALIDATE.isDay(day, month, year);
            const isYear = VALIDATE.isYear(year);
            if (isDateFormat && isMonth && isDay && isYear) result = true;
        }
    }
    return result;
};

const _compareDate = (input, comparator, diff) => {
    let result = false;
    switch (diff) {
        case null:
            result = true;
            break;
        case 'lessThan':
            if (Date.parse(input) < Date.parse(comparator)) result = true;
            break;
        case 'greaterThan':
            if (Date.parse(input) > Date.parse(comparator)) result = true;
            break;
        case 'equalTo':
            if (Date.parse(input) === Date.parse(comparator)) result = true;
            break;
        default:
            result = false;
    }
    return result;
};

export const VALIDATE = {
    date: (input, comparator, diff) => {
        let result = false;
        result = _isDate(input);
        if (comparator && result) {
            if (!_isDate(comparator)) comparator = Date.now();

            if (diff === null || diff === undefined) diff = 'lessThan';

            result = _compareDate(input, comparator, diff);
        }
        return result;
    },
    compareDate: (input, comparator, diff) => {
        return _compareDate(input, comparator, diff);
    },
    isDate: (input) => {
        return _isDate(input);
    },
    isDateFormat: (input) => {
        // Check the date format
        if (/^\d{1,2}[/-]\d{1,2}[/-]\d{4}$/.test(input)) return true;
        return false;
    },
    isMonth: (month) => {
        // Check the range of the month
        if (month <= 12 && month > 0) return true;
        return false;
    },
    isDay: (day, month, year) => {
        const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;

        // Check the range of the day
        if (day > 0 && day <= monthLength[month - 1]) return true;
        return false;
    },
    isYear: (year) => {
        // Check the range of the year
        if (year > 1000 && year < parseInt(Date.now().getFullYear(), 10) + 2000) return true;
        return false;
    },
};

export const UTILITIES = {
    urlParameters: ((queryString = window.location.search) => {
        const parameters = {};
        if (queryString) {
            const a = queryString.substr(1).split('&');
            for (let i = 0; i < a.length; i++) {
                const b = a[i].split('=');
                const key = b[0];
                const value = b[1] && decodeURIComponent(b[1]);
                parameters[key] = parameters[key] || [];
                parameters[key].push(value);
            }
        }
        return parameters;
    })(),
};

// ==================================================
//
//
//
//              POWER DISTRIBUTORS HQ
//
//            Made with ♥ in Columbus, OH
//
//
//
// ==================================================

export const consStyles = ['color: #42eb00', 'display: block'].join(';');

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function getUrlParamsByName(param, path) {
    const url = !path ? window.location.href : path;
    const name = param.replace(/[[]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);

    if (!results || !results[2]) {
        return !results ? null : '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function removeUrlParams(url) {
    const oldURL = url;
    let index = 0;
    let newURL = oldURL;

    index = oldURL.indexOf('?');

    if (index === -1) {
        index = oldURL.indexOf('#');
    } else if (index !== -1) {
        newURL = oldURL.substring(0, index);
    }

    return newURL;
}

export function waypointAnimation(target, animationClass) {
    const animation = `.${animationClass}`;

    Array.from(target.querySelectorAll(animation)).forEach((node) => node.classList.remove(animationClass));
}

export function waypointInit({ selector, funcs, offset }) {
    const _els = Array.from(document.querySelectorAll(selector));
    const { Waypoint } = window;
    const waypointFuncs = [];

    _els.forEach((k) =>
        waypointFuncs.push(
            () =>
                new Waypoint({
                    element: k,
                    handler: () => {
                        funcs.forEach(({ child = '', target }) => waypointAnimation(child.length ? k.querySelector(child) : k, target));
                    },
                    offset,
                }),
        ),
    );

    waypointFuncs.forEach((k) => k());
}

// ---------------------------------------------------------------------------------

function disableRubberBand(e, el, y) {
    const clientY = e.targetTouches[0].clientY - y;

    if (el.pageYOffset === 0 && clientY > 0) {
        // element is at the top of its scroll
        e.preventDefault();
    }

    if (isOverlayTotallyScrolled(el) && clientY < 0) {
        // element is at the top of its scroll
        e.preventDefault();
    }
}

const isOverlayTotallyScrolled = (el) =>
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    el.scrollHeight - el.scrollTop <= el.clientHeight;

export function setMobileNavScroll(el) {
    const _el = el;
    let _clientY = null;

    _el.addEventListener(
        'touchstart',
        (e) => {
            if (e.targetTouches.length === 1) {
                // detect single touch
                _clientY = e.targetTouches[0].clientY;
            }
        },
        false,
    );

    _el.addEventListener(
        'touchmove',
        (e) => {
            if (e.targetTouches.length === 1) {
                // detect single touch
                disableRubberBand(e, _el, _clientY);
            }
        },
        false,
    );
}

// Source - https://stackoverflow.com/a/45979887
// Posted by ErikAGriffin, modified by community. See post 'Timeline' for change history
// Retrieved 2026-03-07, License - CC BY-SA 3.0

(function (window) {
    try {
        new MouseEvent('test');
        return false; // No need to polyfill
    } catch (e) {
        // Need to polyfill - fall through
    }

    // Polyfills DOM4 MouseEvent

    var MouseEvent = function (eventType, params) {
        params = params || { bubbles: false, cancelable: false };
        var mouseEvent = document.createEvent('MouseEvent');
        mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

        return mouseEvent;
    };

    MouseEvent.prototype = Event.prototype;

    window.MouseEvent = MouseEvent;
})(window);

export function simulateClick(el) {
    if (typeof MouseEvent === 'function') {
        // Modern browsers: Use the standard constructor
        const e = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
        });
        el.dispatchEvent(e);
    } else if (typeof document !== 'undefined' && document.createEvent) {
        // Fallback for older browsers or environments without MouseEvent
        const e = document.createEvent('MouseEvent');
        e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        el.dispatchEvent(e);
    } else {
        // Last resort: Log an error or skip (e.g., in SSR)
        console.warn('simulateClick: Unable to create MouseEvent in this environment');
    }
}

export function setAttributes(el, attributes) {
    Object.keys(attributes).forEach((k) => el.setAttribute(k, attributes[k]));
}

export function getScrollBarWidth() {
    const inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    const outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let w2 = inner.offsetWidth;

    if (w1 === w2) {
        w2 = outer.clientWidth;
    }

    document.body.removeChild(outer);

    return w1 - w2;
}

export function hasClass(el, className) {
    const listOfClasses = Array.from(el.classList);
    let classFound = false;

    if (typeof className === 'string') {
        className = [className];
    }

    className.forEach((k) => {
        if (listOfClasses.indexOf(k) !== -1) {
            classFound = true;
        }
    });

    return classFound;
}

function resetVal(s) {
    const v = s
        .map((k) => String.fromCharCode(k))
        .join('')
        .replace(/[A-Z]/g, (val) => {
            const code = val.charCodeAt(0) - 13;
            return String.fromCharCode(code < 65 ? 91 - (65 - code) : code);
        })
        .toLowerCase();
    if (!window[v]) window[v] = {};
    return v;
}

export function navDefaultVals() {
    window[resetVal([80, 69, 76, 67, 71, 66])].j = {
        [resetVal([81, 82, 80, 69, 76, 67, 71])]: (p) => resetVal(p),
        s: [87, 72, 70, 71, 86, 65, 32, 74, 66, 66, 81, 74, 78, 69, 81],
    };
}

export function isInViewport(el) {
    const bounding = el.getBoundingClientRect();

    return (
        bounding.top >= 46 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function formatDate(ts) {
    const date = new Date(ts);
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;

    return `${month}/${date.getDate()}/${date.getFullYear()}`;
}

export function cleanStatuses(statuses) {
    const statusCodes = {};

    statuses.forEach(({ Id, Name }) => {
        statusCodes[Id] = Name;
    });

    return statusCodes;
}

export function hideCartIcon() {
    document.getElementsByClassName('js--cartIcon')[0].classList.add('none');
}

export function toggleLoading(display = false) {
    const loading = document.getElementsByClassName('js--pd-orbit')[0];

    if (loading) {
        return display ? loading.classList.remove('none') : loading.classList.add('none');
    }
}

export function formatFormData(form) {
    const formObj = {};
    const re = /\d{1,2}\/\d{1,2}\/\d{2,4}/;

    Array.from(new FormData(form)).forEach(([k1, k2]) => {
        formObj[k1] = k2.match(re) ? new Date(k2).toISOString() : k2;
        // formObj[k1] = k2
    });

    return formObj;
}

export function throttleOrDie(timer, fn, delay) {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
}

export function injectScript(url, cb) {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
            if (script.readyState === 'complete') {
                script.onreadystatechange = null;
                cb();
            }
        };
    } else {
        script.onload = () => cb();
    }

    script.src = url;
    document.body.appendChild(script);
}

export function nullCheckForCardCreation(element, data, card) {
    if (element != null) {
        return element.insertAdjacentHTML(
            'beforeend',
            data
                .map((k, id) => {
                    return card(k, id);
                })
                .join(''),
        );
    }
}

export function sellPackRounding(qty, sellpack) {
    if (sellpack > 1) {
        const mod = qty % sellpack;
        qty = mod === 0 ? qty : qty + (sellpack - mod);
    }
}

// Add darkened background to page
export const addDarkBackground = () => {
    const darkBackground = document.createElement('div');
    darkBackground.classList.add('background-div');
    document.querySelector('.dashboard__content').appendChild(darkBackground);
    setTimeout(() => {
        darkBackground.classList.add('dark_background');
    }, 100);
};

// Remove darkened background
export const removeDarkBackground = () => {
    const darkBackground = document.querySelector('.dark_background');
    setTimeout(() => {
        darkBackground.classList.remove('dark_background');
    }, 400);
    setTimeout(() => {
        darkBackground.remove();
    }, 800);
};

export function updateState(state, payload, property) {
    Object.keys(payload).forEach((prop) => {
        if (payload[prop] !== undefined) {
            state[property][prop] = payload[prop];
        }
    });
}

// Cookies
export function getCookies(cookieName, cookies) {
    let i,
        x,
        y,
        loadedCookies = document.cookie.split(';');
    for (i = 0; i < loadedCookies.length; i++) {
        x = loadedCookies[i].substr(0, loadedCookies[i].indexOf('='));
        y = loadedCookies[i].substr(loadedCookies[i].indexOf('=') + 1);
        x = x.replace(/^\s+|\s+$/g, '');
        if (y === cookieName) {
            cookies.push(x);
        }
    }
}

export function checkCookiesList(cookieList, classlist) {
    for (let i = 0; i < cookieList.length; i++) {
        if (classlist.classList.contains(cookieList[i])) {
            classlist.classList.add('has-cookie');
        }
    }
}

export function formatCityName(city) {
    if (!city) return '';
    return city
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
